const tweens = [
  'linear', 'quadEaseIn', 'quadEaseOut', 'quadEaseInOut', 'easeInQuad',
  'easeOutQuad', 'easeInOutQuad', 'easeInCubic', 'easeOutCubic', 'easeInOutCubic',
  'easeInQuart', 'easeOutQuart', 'easeInOutQuart', 'easeInQuint', 'easeOutQuint',
  'easeInOutQuint', 'easeInSine', 'easeOutSine', 'easeInOutSine', 'easeInExpo',
  'easeOutExpo', 'easeInOutExpo', 'easeInCirc', 'easeOutCirc', 'easeInOutCirc',
  'easeInElastic', 'easeOutElastic', 'easeInOutElastic', 'easeInBack', 'easeOutBack',
  'easeInOutBack', 'easeInBounce', 'easeOutBounce', 'easeInOutBounce',
].map( (tween) => {
  return {
    name:tween,
    value:tween
  }
});

export default tweens;
